const URL = process.env.REACT_APP_URL;

export default URL;
